import type { UseMutationResult } from '@tanstack/react-query';

// Takes a useMutation hook and returns a promise that resolves with the response data
export function createMutationPromise<Response, Request>(
  mutation: UseMutationResult<Response, unknown, Request>,
  data: Request
): Promise<Response> {
  return new Promise((resolve, reject) => {
    mutation.mutate(data, {
      onSuccess: (response) => {
        resolve(response);
      },
      onError: (err) => {
        reject(err);
      }
    });
  });
}
